import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'

document.querySelectorAll('.slider-brand--swiper').forEach((el) => {
  new Swiper(el, {
    modules: [Autoplay],
    slidesPerView: 2,
    slidesPerGroup: 1,
    spaceBetween: 32,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    speed: 600,
    grabCursor: true,
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 64,
      },
    },
  })
})
